import { render, staticRenderFns } from "./StudyDiscussion.vue?vue&type=template&id=1bb87aa5&"
import script from "./studydiscussion.js?vue&type=script&lang=js&"
export * from "./studydiscussion.js?vue&type=script&lang=js&"
import style0 from "./StudyDiscussion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports